export enum PayGateLanguageCode {
  CS = "CS",
  EN = "EN",
  DE = "DE",
  FR = "FR",
  HU = "HU",
  IT = "IT",
  JP = "JP",
  PL = "PL",
  PT = "PT",
  RO = "RO",
  RU = "RU",
  SK = "SK",
  ES = "ES",
  TR = "TR",
  VN = "VN",
  HR = "HR",
  SI = "SI",
}
